import * as React from 'react';

// Minimal stroke icons. 24x24 viewBox, currentColor.
export const Icon = ({ name, size = 20, strokeWidth = 1.75, style, className }) => {
  const s = { width: size, height: size, display: 'inline-block', verticalAlign: 'middle', ...style };
  const common = {
    width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
    stroke: 'currentColor', strokeWidth, strokeLinecap: 'round', strokeLinejoin: 'round',
    style: s, className
  };
  switch (name) {
    case 'search':
      return (<svg {...common}><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>);
    case 'pin':
      return (<svg {...common}><path d="M12 22s-7-7.5-7-13a7 7 0 1 1 14 0c0 5.5-7 13-7 13Z"/><circle cx="12" cy="9" r="2.5"/></svg>);
    case 'chev-down':
      return (<svg {...common}><path d="m6 9 6 6 6-6"/></svg>);
    case 'chev-right':
      return (<svg {...common}><path d="m9 6 6 6-6 6"/></svg>);
    case 'chev-left':
      return (<svg {...common}><path d="m15 6-6 6 6 6"/></svg>);
    case 'arrow-right':
      return (<svg {...common}><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>);
    case 'check':
      return (<svg {...common}><path d="m5 12 5 5L20 7"/></svg>);
    case 'check-circle':
      return (<svg {...common}><circle cx="12" cy="12" r="9.5"/><path d="m8 12 3 3 5-6"/></svg>);
    case 'x':
      return (<svg {...common}><path d="M6 6 18 18"/><path d="M18 6 6 18"/></svg>);
    case 'video':
      return (<svg {...common}><rect x="3" y="6.5" width="13" height="11" rx="2"/><path d="m16 10 5-2.5v9L16 14"/></svg>);
    case 'calendar':
      return (<svg {...common}><rect x="3.5" y="5" width="17" height="15.5" rx="2.5"/><path d="M3.5 10h17M8 3.5v3M16 3.5v3"/></svg>);
    case 'phone':
      return (<svg {...common}><path d="M5 4.5h3.2l1.8 4-2.3 1.4a13 13 0 0 0 6.4 6.4l1.4-2.3 4 1.8V19a1.5 1.5 0 0 1-1.7 1.5C10.7 19.6 4.4 13.3 3.5 6.2A1.5 1.5 0 0 1 5 4.5Z"/></svg>);
    case 'star':
      return (<svg {...common}><path d="m12 3.5 2.6 5.4 5.9.7-4.4 4.1 1.2 5.9L12 16.7 6.7 19.6l1.2-5.9-4.4-4.1 5.9-.7L12 3.5Z"/></svg>);
    case 'dollar':
      return (<svg {...common}><path d="M12 3v18"/><path d="M16 7.5c0-1.66-1.79-3-4-3s-4 1.34-4 3 1.79 2.5 4 3 4 1.34 4 3-1.79 3-4 3-4-1.34-4-3"/></svg>);
    case 'shield':
      return (<svg {...common}><path d="M12 3 5 5.5v6c0 4 3 7.5 7 9 4-1.5 7-5 7-9v-6L12 3Z"/><path d="m9 12 2 2 4-4"/></svg>);
    case 'sliders':
      return (<svg {...common}><path d="M4 7h10M18 7h2M4 17h2M10 17h10"/><circle cx="16" cy="7" r="2"/><circle cx="8" cy="17" r="2"/></svg>);
    case 'grid':
      return (<svg {...common}><rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/></svg>);
    case 'home':
      return (<svg {...common}><path d="M4 11 12 4l8 7"/><path d="M6 10v9.5h12V10"/></svg>);
    case 'calendar-check':
      return (<svg {...common}><rect x="3.5" y="5" width="17" height="15.5" rx="2.5"/><path d="M3.5 10h17M8 3.5v3M16 3.5v3"/><path d="m9 14.5 2 2 4-4"/></svg>);
    case 'user':
      return (<svg {...common}><circle cx="12" cy="8" r="3.5"/><path d="M5 20c1-3.5 4-5 7-5s6 1.5 7 5"/></svg>);
    case 'inbox':
      return (<svg {...common}><path d="M4 13l2.5-7h11L20 13"/><path d="M4 13v6h16v-6h-5l-1.5 2.5h-3L9 13H4Z"/></svg>);
    case 'bell':
      return (<svg {...common}><path d="M6 16V11a6 6 0 1 1 12 0v5l1.5 2h-15L6 16Z"/><path d="M10 20a2 2 0 0 0 4 0"/></svg>);
    case 'image':
      return (<svg {...common}><rect x="3.5" y="4.5" width="17" height="15" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m4 18 5-5 4 4 3-3 4 4"/></svg>);
    case 'edit':
      return (<svg {...common}><path d="M4 20h4l10.5-10.5-4-4L4 16v4Z"/><path d="m14 5.5 4 4"/></svg>);
    case 'logo-leaf':
      return (
        <svg width={size} height={size} viewBox="0 0 24 24" style={s}>
          <path d="M4 14c0-5 4-9 9-9h6v6c0 5-4 9-9 9H4v-6Z" fill="currentColor"/>
          <path d="M19 5 8 16" stroke="#FAF6F0" strokeWidth="1.6" strokeLinecap="round" fill="none"/>
        </svg>
      );
    case 'spark':
      return (<svg {...common}><path d="M12 4v4M12 16v4M4 12h4M16 12h4M6.5 6.5l2.8 2.8M14.7 14.7l2.8 2.8M6.5 17.5l2.8-2.8M14.7 9.3l2.8-2.8"/></svg>);
    case 'menu':
      return (<svg {...common}><path d="M4 7h16M4 12h16M4 17h16"/></svg>);
    case 'plus':
      return (<svg {...common}><path d="M12 5v14M5 12h14"/></svg>);
    case 'heart':
      return (<svg {...common}><path d="M20.8 5.8a5.2 5.2 0 0 0-7.4 0L12 7.2l-1.4-1.4a5.2 5.2 0 1 0-7.4 7.4L12 22l8.8-8.8a5.2 5.2 0 0 0 0-7.4Z"/></svg>);
    case 'message':
      return (<svg {...common}><path d="M4 5.5h16v11H9l-5 4v-15Z"/><path d="M8 10h8M8 13h5"/></svg>);
    default:
      return null;
  }
};
